import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GenericService } from '../../generic.service';
import { defaultLanguage } from '../constants/language.constants';
import { LandingService } from '../../landing-page/service/landing.service';
import { CrowdinService } from '../service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-header',
    imports: [CommonModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  deviceData: any = {};
  deviceData$: any = null;
  accountNumber: string = '';
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  goBack() {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    history.go(-1);
  }

  navigateToLadingPage() {
    this.landingService.navigateToHomePage();
  }
}
